<script>
export default {
    name: "members-list",
    data() {
        return {};
    },
    computed: {
        members() {
            return this.$store.getters.members;
        },
        firstLetters() {
            if (this.members) {
                let firstLetters = [];
                this.members.forEach(m => {
                    var letter = m.companyName ? m.companyName.charAt(0) : null;
                    if (letter) {
                        firstLetters.push(letter);
                    }
                });
                return firstLetters.filter(
                    (value, index, array) => array.indexOf(value) === index
                );
            }
        }
    },
    methods: {
        companiesStartingWith(letter) {
            return this.members.filter(
                member => member.companyName ? member.companyName.charAt(0) == letter : false
            );
        }
    }
};
</script>

<template>
    <div class="wide membersGrouped" id="memberlist">
        <div v-for="letter in firstLetters" class="leading-normal" :key="letter">
            <div v-if="companiesStartingWith(letter).length > 0">
                <h3 class="mb-2 text-beige text-2xl ml-4" :id="letter">{{ letter }}</h3>
                <div class="white-card">
                    <div class="company-columns">
                        <div
                            v-for="company in companiesStartingWith(letter)"
                            :key="company.id"
                            class="directory-member"
                            :id="company.id"
                        >
                            <a :href="company.profile" class="link">{{ company.companyName}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
